/**
 * This file contains all of the actions used for the deleted package tutorial.
 *
 * This package looks like a tutorial, but does not behave like most other tutorials in that it has
 * no state on the server. It is triggered every time a deleted package is clicked.
 */

export const TRIGGER_DELETED_PACKAGE_TUTORIAL = 'TRIGGER_DELETED_PACKAGE_TUTORIAL';
export const DISMISS_DELETED_PACKAGE_TUTORIAL = 'DISMISS_DELETED_PACKAGE_TUTORIAL';

/**
 * Action that is fired when the deleted package tutorial should appear.
 */
export function triggerDeletedPackageTutorial(packageID) {
    return {
        type: TRIGGER_DELETED_PACKAGE_TUTORIAL,
        packageID,
    };
}

/**
 * Action that is fired when the deleted package tutorial has been dismissed.
 */
export function dismissDeletedPackageTutorial() {
    return { type: DISMISS_DELETED_PACKAGE_TUTORIAL };
}
